export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/LXGWWenKaiMonoTC-Regular.f3bb6073-216295.ttf";